import { IAppState } from '../../../store/appState';
import { Gebaeude, Nebengebaeude } from '../../../store/reducers/gebaeude.reducer';

export const selectGebaeude = (state: IAppState): Gebaeude => state.gebaeude;

export const selectNebengebaeude = (state: IAppState): Nebengebaeude =>
  state.gebaeude.nebengebaeude;

export const isNebengebaeudeVorhanden = (state: IAppState): string =>
  state.gebaeude.nebengebaeude.vorhanden !== null
    ? String(state.gebaeude.nebengebaeude.vorhanden)
    : null;

export const baujahr = (state: IAppState): number =>
  state.gebaeude ? state.gebaeude.baujahr : null;

export const wohnflaeche = (state: IAppState): number =>
  state.gebaeude ? state.gebaeude.wohnflaeche : null;

export const isDenkmalschutzSelectableByValue = (dasBaujahr: number): boolean =>
  dasBaujahr !== null && dasBaujahr <= 1970;

export const isGebaeudeYoungerThanFiveYears = (dasBaujahr: number): boolean =>
  dasBaujahr != null && new Date().getFullYear() - dasBaujahr < 5;

export const isDenkmalschutzSelectable = (state: IAppState): boolean =>
  isDenkmalschutzSelectableByValue(state.gebaeude.baujahr);

export function isVorschaedenVisibleByValue(dasBaujahr: number): boolean {
  const currentYear = new Date().getFullYear();
  return dasBaujahr !== null && currentYear - dasBaujahr > 5;
}

export const isVorschaedenVisible = (state: IAppState): boolean => {
  return isVorschaedenVisibleByValue(state.gebaeude.baujahr);
};

export const isSchwimmbadSelectableByValue = (wohnflache: number): boolean =>
  wohnflache != null && wohnflache > 99;

export const isSchwimmbadSelectable = (state: IAppState): boolean =>
  isSchwimmbadSelectableByValue(state.gebaeude.wohnflaeche);

export const isFeuerrohbauSelectable = (state: IAppState): boolean =>
  !state.vertragsoptionen.vorvertragsNummern;
